import { read, utils } from "xlsx";

export const getFormatDateTimeHelper = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}${month}${day}${hour}${minute}`;
};

export const getCurrentLastDateHelper = () => {
  const today = new Date();
  const previousDay = new Date();
  previousDay.setDate(today.getDate() - 1);

  const startDate = `${previousDay.getFullYear()}/${String(previousDay.getMonth() + 1).padStart(2, "0")}/${String(previousDay.getDate()).padStart(2, "0")}`;
  const endDate = `${today.getFullYear()}/${String(today.getMonth() + 1).padStart(2, "0")}/${String(today.getDate()).padStart(2, "0")}`;

  return { startDate, endDate };
};

export const formatExcelDateHelper = (value, excelSerialToDateFn) => {
  if (value === undefined || value === null || value === "") {
    return "";
  }

  const toIsoDate = (dateValue) => {
    const dateObj = new Date(dateValue);
    if (isNaN(dateObj.getTime())) {
      return "";
    }
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  if (typeof value === "number" && Number.isFinite(value)) {
    const convertedDate = excelSerialToDateFn(value);
    return convertedDate ? toIsoDate(convertedDate) : "";
  }

  if (value instanceof Date && !isNaN(value.getTime())) {
    return toIsoDate(value);
  }

  const valueStr = value.toString().trim();
  if (!valueStr) {
    return "";
  }

  if (/^\d+(\.\d+)?$/.test(valueStr)) {
    const convertedDate = excelSerialToDateFn(parseFloat(valueStr));
    return convertedDate ? toIsoDate(convertedDate) : "";
  }

  const normalizedDate = toIsoDate(valueStr);
  if (normalizedDate) {
    return normalizedDate;
  }

  return valueStr;
};

export const parseExcelFileHelper = (file, { onStart, onSuccess, onError }) => {
  const reader = new FileReader();
  if (onStart) onStart();

  reader.onload = (e) => {
    try {
      const workbook = read(e.target.result, { type: "binary" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = utils.sheet_to_json(worksheet, { header: 1 });
      if (onSuccess) onSuccess(jsonData);
    } catch (error) {
      if (onError) onError(error);
    }
  };

  reader.onerror = (error) => {
    if (onError) onError(error);
  };

  reader.readAsBinaryString(file);
};

export const debounceShippingBillFetchHelper = (vm, delay = 1000) => {
  clearTimeout(vm.debounce);
  vm.debounce = setTimeout(() => {
    vm.getBulkShippingBillList("Normal", "0", "0", "1", "1");
  }, delay);
};



// WEBPACK FOOTER //
// ./src/helper/shippingBillUploadHelper.js